import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import playWorkoutSlice, {
  selectWorkoutActive,
  selectWorkoutSession,
  restRemainingSeconds
} from 'store/modules/playWorkout';

/**
 * OTRIX Play — piloto automático del entrenamiento. Montado UNA sola vez (en la mini-barra del
 * layout) para que corra en todas las pantallas: cuando el descanso llega a 0, avanza solo a la
 * siguiente serie/ejercicio. No renderiza nada; solo despacha `endRest` en el borde.
 */
export const usePlayWorkoutTimer = () => {
  const dispatch = useDispatch();
  const active = useSelector(selectWorkoutActive);
  const session = useSelector(selectWorkoutSession);
  const phase = session?.phase;
  const guardRef = useRef(false);

  useEffect(() => {
    if (!active || phase !== 'rest') {
      guardRef.current = false;
      return undefined;
    }
    const id = setInterval(() => {
      const remaining = restRemainingSeconds(session, Date.now());
      if (remaining <= 0 && !guardRef.current) {
        guardRef.current = true;
        dispatch(playWorkoutSlice.actions.endRest({ now: Date.now() }));
      }
    }, 500);
    return () => clearInterval(id);
  }, [active, phase, session, dispatch]);
};

/**
 * Reloj para la UI: devuelve `Date.now()` refrescado cada `intervalMs` mientras `active`.
 * Los segundos reales se derivan de timestamps (ver slice), esto solo fuerza el re-render.
 */
export const useWorkoutTick = (active, intervalMs = 1000) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!active) return undefined;
    setNow(Date.now());
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [active, intervalMs]);

  return now;
};

export default usePlayWorkoutTimer;
